<ng-template porFeatureAvailability [featureToken]="['canHaveProductsKeyDocumentsView']" [fallbackTemplate]="defaultTemplate">
    <ng-container [ngTemplateOutlet]="productDetailDocumentsTemplate"></ng-container>
</ng-template>
<ng-template #defaultTemplate>
    <ng-container [ngTemplateOutlet]="productDetailNormalTemplate"></ng-container>
</ng-template>

<ng-template #productDetailNormalTemplate>
    <div class="product-details-page">
        <div class="header">
            <h1 class="theme-heading">{{ (isPublicView ? 'StockDetails' : 'ProductDetails') | translate }}</h1>
            @if (showCloseButton) {
                <por-base-button (click)="closePanel.emit(true)" icon="close" featureName="product-detail-close-button"></por-base-button>
            }
        </div>
        <div class="public-product-info" *ngIf="isPublicView && productDetail">
            <h1 *ngIf="isContentAvailable('Name')" class="title">
                {{ productDetail.Name }}
                <span *ngIf="isContentAvailable('SerialNumber')" class="serial-number">{{ productDetail.SerialNumber }}</span>
            </h1>
            <p *ngIf="isContentAvailable('Description')" class="product-description">{{ productDetail.Description }}</p>
        </div>

        <div class="wrapper-product">
            <div class="content">
                <ng-container *ngIf="isPublicView; else defaultDocumentsInformation">
                    <ng-container [ngTemplateOutlet]="documentsList"></ng-container>
                </ng-container>
                <ng-template #defaultDocumentsInformation>
                    <ng-container [ngTemplateOutlet]="documentsInformation"></ng-container>
                </ng-template>
            </div>
            @if (isContentAvailable('OtherUrls')) {
            <div class="links">
                <h3 class="title">{{ 'Documents' | translate }}</h3>
                @for (link of productDetail?.OtherUrls; track link) {
                <a [href]="link" target="_blank">
                    <img src="{{ uiUrl }}/assets/images/noun-pdf-file-5441350Gray.svg" />
                </a>
                }
            </div>
            }
        </div>
    </div>
</ng-template>
<ng-template #productDetailDocumentsTemplate>
    <div class="product-details-page document-template">
        @if (!isMobileLayout) {
        <div class="top-bar">
            <h1 class="theme-heading">{{ 'ProductDetails' | translate }}</h1>
        </div>
        }
        <div class="header">
            @if (isContentAvailable('Name')) {
            <h1 class="title">
                {{ productDetail?.Name }}
                @if (isContentAvailable('SerialNumber')) {
                <span [ngClass]="{ 'd-flex': isMobileLayout }">
                    {{ productDetail?.SerialNumber }}
                </span>
                }
            </h1>
            }
            @if (showCloseButton) {
                <por-base-button (click)="closePanel.emit(true)" icon="close" featureName="product-detail-close-button"></por-base-button>
            }
        </div>
        <div class="sub-header">
            <h3>{{ 'Documents' | translate }}</h3>
        </div>
        <div class="wrapper-product">
            <div class="content">
                <div class="cols d-flex full-width">
                    <div class="col-50" [ngClass]="{ 'no-product-data': !isContentAvailable('Images') && !isContentAvailable('StoredFiles') && !isContentAvailable('Description') }">
                        <ng-container [ngTemplateOutlet]="documentsList"></ng-container>
                    </div>
                    @if (isContentAvailable('Images') || isContentAvailable('StoredFiles') || isContentAvailable('Description')) {
                    <div class="col-50">
                        <ng-container [ngTemplateOutlet]="documentsInformation"></ng-container>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #documentsList>
    <por-document-lists [uiUrl]="uiUrl ?? ''" [documentParams]="documentParams"></por-document-lists>
    <div class="documents">
        @if (showSendDocument && (appFacadeService.checkIfDocumentsExist() | async) && !isPublicView) { 
            <div>
                <div class="text-align-center">
                    <button class="btn-link d-inline-flex" porAddFeature featureName="send-taglink-btn" (click)="openModal()">
                        <img class="actions-image" src="{{ uiUrl }}/assets/images/mail-signal-1684972-1442449.svg" porAddFeature featureName="send-taglink-btn" />
                        <label porAddFeature featureName="send-taglink-btn">{{ 'SendDocument' | translate }}</label>
                    </button>
                </div>
            </div>
        }
    </div>
</ng-template>
<ng-template #documentsInformation>
    @if (isContentAvailable('Images')) {
    <div class="image-section">
        <img [src]="productDetail?.Images?.[0]?.['Uri']" [alt]="productDetail?.Images?.[0]?.['AltText']" />
    </div>
    } @if (isContentAvailable('StoredFiles')) {
    <div class="image-section">
        <img [src]="productDetail?.StoredFiles?.[0]?.['PublicURL']" />
    </div>
    } @if (productDetail) {
    <div class="description">
        <ng-template porFeatureAvailability [featureToken]="['canHaveProductsKeyDocumentsView']" [fallbackTemplate]="productName"></ng-template>
        <ng-template #productName>
            @if (isContentAvailable('Name')) {
            <h3 class="title">{{ productDetail.Name }}</h3>
            }
        </ng-template>
        @if (isContentAvailable('Description')) {
        <span>{{ productDetail.Description }}</span>
        }
    </div>
    }
</ng-template>

<por-base-modal [id]="'product-detail-modal'" [modalWidth]="'modal-lg'">
    <por-send-document-link
        [sendLinkRequestData]="sendLinkRequestData"
        (isFormReturn)="handleRentalFormReturn()"
        (sendLinkRequestInfo)="handleSendDocumentFormSubmission($event)"></por-send-document-link>
</por-base-modal>
